import Box from '@mui/material/Box'
import React, {  } from 'react'

import NavCard from './NavCard.js'
import NavSubLogo from './nav-sub-logo.svg'
import { useNavigate } from 'react-router-dom'
import routes from 'routes'

var sx = {
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
}

export default function NavMain() {
  const navigate = useNavigate()

  const onNavClick = e => {
    e && e.preventDefault()
    navigate(routes.find)
  }

  return (
    <Box sx={sx.center}>
      <div>
        <NavCard
          imageURL={NavSubLogo}
          title="Investigate a new business"
          body="Provide business information to have Markaaz 360 perform a business search against our business directory."
          buttonText="Find a Business"
          onClick={onNavClick}
        ></NavCard>
      </div>
    </Box>
  )
}
